<app-layout>
  <app-urun-grup-sec-modal [source]="parentUrunGruplari" [show]="showSelectUrunGrupModalTs"
                           (selectedUrunGrup)="selectUrunGrup($event)"></app-urun-grup-sec-modal>
  <div class="row">
    <div class="col-12" *ngIf="urunGrup">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{id === '0' ? 'Yeni Ürün Grubu' : 'Ürün Grubu Düzenle'}}</h4>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="save()"
                 [ngClass]="{'disabled':urunGrup.isim.length===0}">
              Kaydet
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Ürün Grubu Adı</div>
                <input type="text" class="form-control" placeholder="Ürün grubu adı" [(ngModel)]="urunGrup.isim">
              </div>
              <div class="mb-3">
                <div class="form-label">Tahmini Teslim Gün Sayısı</div>
                <input type="number" class="form-control" placeholder="Tahmini teslim gün sayısı"
                       [(ngModel)]="urunGrup.tahminiTeslimGun">
              </div>
              <div class="mb-3">
                <div class="form-label">Ürün Grubu <span *ngIf="selectedParent!=null" class="text-warning clickable" (click)="clear()">Temizle</span></div>
                <input type="text" class="form-control clickable" placeholder="Ürün grubu adı" [readOnly]="true"
                       [value]="selectedParent?.isim" (click)="showSelectUrunGrup()">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="id!=='0'">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Alt Ürün Grupları</h4>
        </div>
        <div class="card-body p-0" *ngIf="urunGrup?.childrens">
          <app-urun-grup-liste [source]="urunGrup?.childrens" (view)="incele($event)"
                               (delete)="kaldir($event)"></app-urun-grup-liste>
        </div>
      </div>
    </div>
  </div>
</app-layout>
